<button mat-icon-button [matMenuTriggerFor]="actionsMenu">
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #actionsMenu="matMenu">
  <ng-template matMenuContent>
    <button mat-menu-item (click)="editName()">
      <mat-icon>edit</mat-icon>
      <span>Edit Name</span>
    </button>

    @if (isTest$ | async) {
      <button mat-menu-item (click)="markLive()">
        <mat-icon>publish</mat-icon>
        <span>Set As Live</span>
      </button>
    }
    @if ((isLive$ | async) || (isInactive$ | async)) {
      <button mat-menu-item (click)="markTesting()">
        <mat-icon>replay</mat-icon>
        <span>Set As Testing</span>
      </button>
    }
    @if ((isLive$ | async) || (isTest$ | async)) {
      <button mat-menu-item (click)="markInactive()">
        <mat-icon color="warn">cancel</mat-icon>
        <span>Set As Inactive</span>
      </button>
    }
  </ng-template>
</mat-menu>
